import { BottomNavigation, BottomNavigationAction, Box, Hidden, Icon, Menu, MenuItem, styled } from "@mui/material";
import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { AppToolbar } from "../_components/toolbar/app.toolbar";
import { ADMIN_NAV, PRIMARY_NAV, USER_NAV } from "../_const/navigation.const";
import { accountService } from "../_services/accounts.service";

const drawerWidth = 240;

const useStyles = {

    appScreen: {
        display: 'flex',
        backgroundColor: "#e6e6e6",
        height: "100%"
    },
    main: {
        marginTop: "40px"
    },
    root: {

    },
    mainBackground: {},
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        borderTop: '1px solid #e6e6e6',
        zIndex: 9999
    },
    toolbar: {},
};

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    // width: 'calc(100% - 500px)',
    maxWidth: "calc(100%)",
    width: '100%',
    paddingTop: `calc(${theme.mixins.toolbar.minHeight}px + ${theme.spacing(1)})`,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));


export function AppScreen() {
    const [value, setValue] = React.useState(0);
    const [isOpen, setIsOpen] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const goTo = useNavigate();
    const [selectedListItem, setSelectedListItem] = useState(null);


    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, nav: any) => {
        setAnchorEl(null);
        if (nav && nav.url)
            goTo(nav.url);
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    }

    const handleSelectedItemClick = (item: any) => {
        setSelectedListItem(item);
    };

    return (
        <div style={useStyles.appScreen} id="app-screen">

            <AppToolbar toggleSidebar={toggleSidebar} isOpen={isOpen}></AppToolbar>

            {/* <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}> */}
            {/* <AppSidebar isOpen={isOpen}></AppSidebar> */}
            {/* </Box> */}

            <Main open={isOpen}>
                <Box sx={{ p: { xs: 1, md: 4 } }}>
                    <Outlet></Outlet>
                </Box>
            </Main>



        </div >
    );
}